import { useContext, useEffect } from 'react'
import { Node, Schema } from 'prosemirror-model'
import { useArticle } from '../queries/articles/useArticle'
import { EditorStateContext, EditorViewContext } from '../../common/Prose/EditorProvider/EditorProviderContext'
import templatesStore from 'stores/TemplatesStore'
import { ArticleMeta } from '../../types'
import { ArticleClient } from '../../api/clients/ArticleClient'
import templateStore from '../../stores/TemplatesStore'
import { reportError } from '../../utils/error'

const useTemplateChangeListener = (article: ArticleMeta) => {
  // Apply template to article
  const editorState = useContext(EditorStateContext)
  const editorView = useContext(EditorViewContext)
  const selectedTemplate = templatesStore.selectedPickerTemplate

  const selectedArticleQuery = useArticle(selectedTemplate || '', {
    retry: false,
    enabled: !!selectedTemplate,
  })

  const { article: selectedArticleMeta } = selectedArticleQuery.data || {}

  // Preview template on selectedPickerTemplate change
  useEffect(() => {
    if (!selectedArticleMeta || selectedTemplate !== selectedArticleMeta?.id) {
      return
    }

    if (!editorState || !editorView) {
      return
    }

    const prepareNodes = (elements: any[], schema: Schema): Node[] => {
      return elements.map((node) => {
        return Node.fromJSON(schema, node.data_json)
      })
    }

    const tr = editorState.tr

    let nodes: Node[] | null = null
    nodes = prepareNodes(selectedArticleMeta.elements, editorView.state.schema)

    setTimeout(() => {
      tr.setMeta('TEMPLATE_PREVIEW', true)
      tr.replaceWith(0, editorState.doc.content.size, nodes as Node[])
      editorView.dispatch(tr)
    }, 100)
  }, [selectedArticleMeta, selectedTemplate, editorView]) // eslint-disable-line

  // Track usage on trackTemplateUsage change
  useEffect(() => {
    if (!templatesStore.trackTemplateUsage || !selectedArticleMeta) {
      return
    }

    ArticleClient.trackCopyUsage(article.id, selectedArticleMeta.id)
      .catch((e) => {
        reportError(e)
      })
      .finally(() => {
        templatesStore.closePicker()
        templateStore.setState({
          trackTemplateUsage: false,
        })
      })
  }, [article.id, templatesStore.trackTemplateUsage, selectedArticleMeta]) // eslint-disable-line
}

export default useTemplateChangeListener
